import { render, staticRenderFns } from "./discountTable.vue?vue&type=template&id=45c1fd97&scoped=true&"
import script from "./discountTable.vue?vue&type=script&lang=js&"
export * from "./discountTable.vue?vue&type=script&lang=js&"
import style0 from "./discountTable.vue?vue&type=style&index=0&id=45c1fd97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1fd97",
  null
  
)

export default component.exports